import { COMPONENT_IDS } from '@highereducation/hen-ui/catalog';
import type {
  InteractionRegistry,
  ViewRegistry,
} from '@highereducation/eventing';

export const henSiteInteractionRegistry: InteractionRegistry = new Map([
  [
    COMPONENT_IDS.Link,
    {
      componentId: COMPONENT_IDS.Link,
      eventKey: 'hen.link.clicked',
    },
  ],
  [
    COMPONENT_IDS.Button,
    {
      componentId: COMPONENT_IDS.Button,
      eventKey: 'hen.button.clicked',
    },
  ],
]);

export const henSiteViewRegistry: ViewRegistry = new Map([
  [
    COMPONENT_IDS.Navbar,
    {
      componentId: COMPONENT_IDS.Navbar,
      eventKey: 'hen.navbar.viewed',
    },
  ],
  [
    COMPONENT_IDS.Hero,
    {
      componentId: COMPONENT_IDS.Hero,
      eventKey: 'hen.hero.viewed',
    },
  ],
  [
    COMPONENT_IDS.ArticleCard,
    {
      componentId: COMPONENT_IDS.ArticleCard,
      eventKey: 'hen.card.viewed',
    },
  ],
  [
    COMPONENT_IDS.EmailBanner,
    {
      componentId: COMPONENT_IDS.EmailBanner,
      eventKey: 'hen.emailBanner.viewed',
    },
  ],
]);
